import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BLOCK_MODULE_NAMESPACE, BLOCK_GET_BLOCKS, BLOCK_RESET_BLOCKS, BLOCK_SET_PAREMETER, BLOCK_SET_LOADER_STATE, BLOCK_LOADERS } from '../../../store/block';
import { BlockParameter, IBlockParameter } from '../../../models/block';
import { IBlockListingViewModel, BlockListingViewModel } from '../../../models/block/block-listing.viewmodel';
import { ActivityStatus } from '../../../common/enums';

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
@Component({
  components: {
    'grid-item': async () => import('../components/block-grid-item/BlockGridItem.vue'),
    'grid-condition': async () => import('../components/block-conditions/BlockConditions.vue'),
    'grid-loader': async () => import('../loaders/block-list-loader/BlockListLoader.vue')
  }
})
class BlockGrid extends Vue {
  dtStyle: any;
  dtPreviousWidth: number = window.innerWidth;

  /**
   * Store declaration
   */
  @BlockStore.Getter blocks: IBlockListingViewModel[];
  @BlockStore.Getter pagination: IBlockListingViewModel[];
  @BlockStore.Getter activityStatus: ActivityStatus;
  @BlockStore.Getter blockParameter: BlockParameter;

  @BlockStore.Action(BLOCK_GET_BLOCKS)
  storeGetBlocks: (param?: BlockParameter) => Promise<BlockListingViewModel[]>
  @BlockStore.Mutation(BLOCK_RESET_BLOCKS)
  storeResetBlocks: () => void;
  @BlockStore.Mutation(BLOCK_SET_PAREMETER)
  storeSetBlockParameter: (parameter: IBlockParameter) => void;
  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void
  /**
   *
   */
  constructor() {
    super();
    this.dtStyle = null;
  }

  get lblSetting() {
    return { ...require('@/locales/block').default }
  }

  get coTitle(): string {
    return this.$t(this.lblSetting.blockAllBlockTitle).toString()
  }

  get coParameter(): BlockParameter {
    return this.blockParameter;
  }
  set coParameter(value: BlockParameter) {
    this.storeSetBlockParameter(value)
  }

  get coSearchParameter() {
    return {
      param: this.coParameter,
      merge: true
    }
  }

  initMapContainer() {
    let intervalMapTracer: any;
    let isCleared: boolean;
    this.$nextTick(() => {
      isCleared = false;
      if (!isCleared) {
        intervalMapTracer = setInterval(() => {
          clearInterval(intervalMapTracer);
          let mainContainer = document.getElementsByClassName('main-container')[0];
          if (mainContainer) {
            let width: number = ((mainContainer.clientWidth - 400) / 4);
            if (width > 280) width = 280;
            this.dtStyle = {
              width: width + 'px !important',
              'min-width': width + 'px !important',
              'max-width': width + 'px !important',
              height: width + 'px  !important',
              'min-height': width + 'px  !important',
              'max-height': width + 'px  !important'
            }

          }
        }, 300)
      }

    })
  }
  mounted() {
    this.initMapContainer()
    if (this.$route.path.indexOf('block') > -1) {
      window.onresize = () => this.initMapContainer();
    }
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.dtStyle = getStyle(this.$refs['blockRef'] || {}, 300);
    //     console.log(this.dtStyle, this.$refs['blockRef'])
    //   }, 3000);
    // })
    // window.onresize = () => {

    //   const previousWidth: number = parseInt(this.dtStyle.height.replace('px'));

    //   //@ts-ignore
    //   const newWidth: number = this.$refs['blockRef'].clientWidth;
    //   if (this.dtPreviousWidth > window.innerWidth) {
    //     this.dtStyle = getStyle(this.$refs['blockRef'], newWidth);
    //   } else {
    //     this.dtStyle = getStyle(this.$refs['blockRef'], 300);
    //   }
    //   console.log(this.dtStyle, 'dtStyle')
    //   this.dtPreviousWidth = window.innerWidth;

    // }
    this.storeResetBlocks()
  }

  setListLoaderState(value: boolean){
    this.storeSetLoaderState({ key: BLOCK_LOADERS.LIST, value })
  }

}

export default BlockGrid;



// WEBPACK FOOTER //
// ./src/containers/block/block-grid/index.ts